const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfBalance extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfBalance,
            "Each civilization scores culture equal to double the amount of whatever it produces the least (science, culture, food, or resource). Ignore corruption and consumption.",
            {}
        )
    }
}

module.exports = ImpactOfBalance;